<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters">
      <v-col cols="3">
        <v-text-field
          v-model="search"
          @input="debounceSearch"
          prepend-icon="mdi-magnify"
          label="Search here ..."
          single-line
          solo
          hide-details
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table
              :headers="headers"
              :items="tableItems"
              :server-items-length="pagination?.total || 0"
              :options.sync="options"
              :loading="isLoading"
              :items-per-page="options.itemsPerPage"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }"
              @update:options="handleOptionsChange"
              disable-sort
            >
              <!-- Loading -->
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary" />
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>

              <!-- No data -->
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>

              <!-- No results -->
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>

              <!-- SL -->
              <template v-slot:item.sl="{ index }">
                {{ (options.page - 1) * options.itemsPerPage + (index + 1) }}
              </template>

              <!-- Investor Account (you said investor account means account_no) -->
              <template v-slot:item.account_no="{ item }">
                {{ item.account_no }}
              </template>

              <!-- Manager Account -->
              <template v-slot:item.manager_account="{ item }">
                {{ item.manager_account }}
              </template>

              <!-- Manager Username -->
              <template v-slot:item.manager_username="{ item }">
                {{ item.manager_username || "-" }}
              </template>

              <!-- Action -->
              <template v-slot:item.details="{ item }">

                <router-link
                  class="links text-decoration-none"
                  :to="`/manager-details?id=${item.manager_id}&account=${item.manager_account}`"
                >
                  <v-icon color="#039de9" small>mdi-eye-outline</v-icon>
                </router-link>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "Sl", align: "center", value: "sl" },
        { text: "Investor Account", value: "account_no" },        // ✅ from API
        { text: "Manager Account", value: "manager_account" },    // ✅ from API
        { text: "Manager Username", value: "manager_username" },  // ✅ from API
      ],
    };
  },

  computed: {
    // keep your original state mapping
    ...mapState("investor", ["investorLists", "pagination", "isLoading"]),

    // ✅ IMPORTANT: v-data-table needs an array. Your response is {data:[], total...}
    tableItems() {
      if (Array.isArray(this.investorLists)) return this.investorLists;
      if (this.investorLists && Array.isArray(this.investorLists.data)) return this.investorLists.data;
      return [];
    },
  },

  methods: {
    // keep your original action mapping
    ...mapActions("investor", [
      MAM__ACTIONS.GETALLINVESTORS,
      MAM__ACTIONS.CHANGEMANAGERSTATUS,
    ]),

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[MAM__ACTIONS.GETALLINVESTORS](parameter);
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.options.page = 1; // reset page on new search
        this.fetchData();
      }, 500);
    },

    handleOptionsChange() {
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData();

    if (this.$canRoute("managers") === 1) {
      this.headers.push({ text: "Action", value: "details" });
    }
  },
};
</script>
